import React, { useState } from 'react';
import { Button, ButtonGroup, Card, Text } from '@fragments';
import {
    IconChevronLeft,
    IconChevronRight,
    IconCreditCard,
    IconPlus,
    IconWifi,
} from '@tabler/icons-react';
import './styles.scss';

const PERIOD_OPTIONS = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
];

export default function SpendingLimit() {
    const [period, setPeriod] = useState('weekly');

    return (
        <Card
            flat
            noBodyPadding
            title="My Cards"
            icon={<IconCreditCard />}
            action={
                <Button variant="text" color="inverse" size="small" startIcon={<IconPlus />}>
                    Add Card
                </Button>
            }
        >
            <div className="spending-limit-card">
                <div className="spending-limit-card__visual">
                    <div className="spending-limit-card__top">
                        <span className="spending-limit-card__brand" />
                        <IconWifi />
                        <span className="spending-limit-card__status">Active</span>
                        <span className="spending-limit-card__network"><span /><span /></span>
                    </div>

                    <div className="spending-limit-card__bottom">
                        <Text.caption contrast={6}>Savings Card</Text.caption>
                        <Text.h2 weight={500} contrast={10}>$16,058.94</Text.h2>
                    </div>

                    <div className="spending-limit-card__pager">
                        <button type="button" disabled><IconChevronLeft /></button>
                        <button type="button"><IconChevronRight /></button>
                    </div>
                </div>

                <ButtonGroup
                    grow
                    size="small"
                    options={PERIOD_OPTIONS}
                    value={period}
                    onChange={setPeriod}
                />

                <button type="button" className="spending-limit-card__limit-row">
                    <span className="spending-limit-card__ring" aria-hidden="true">
                        <svg viewBox="0 0 44 44">
                            <circle cx="22" cy="22" r="17" />
                            <circle cx="22" cy="22" r="17" />
                        </svg>
                    </span>

                    <span className="spending-limit-card__copy">
                        <Text.caption contrast={6}>Spending Limit</Text.caption>
                        <span>
                            <Text.h5 weight={500} contrast={10}>$1,500.00</Text.h5>
                            <Text.caption contrast={6}>/ week</Text.caption>
                        </span>
                    </span>

                    <IconChevronRight className="spending-limit-card__chevron" />
                </button>
            </div>
        </Card>
    );
}
